export const BASE_URL = 'https://staging.appnewsdelivery.net/api/';

export const API_KEY = 'AN-ADMIN-key-FO5ZaiPTGwcgiSanGv5BnSof';

export const RECAPTCHA_SITE_KEY = '6LdCKGIgAAAAAH8Q8hXXQHqYgf7BEe6d7nulAV9U';
